<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import ElDialog from '../Dialog.vue';
import TrekButton from '@/components/TrekButton';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import CartProductsList from '@/components/cart/CartProductsList';

export default {
  components: {
    TrekButton,
    ElDialog,
    PdlTabs,
    PdlTabPane,
    CartProductsList,
  },
  props: {
    bikes: {
      type: Array,
      default: () => [],
    },
    parts: {
      type: Array,
      default: () => [],
    },
    customWaterBottles: {
      type: Array,
      default: () => [],
    },
    projectOneBikes: {
      type: Array,
      default: () => [],
    },
    cartSummary: {
      type: Object,
      default: () => {},
    },
    cartId: {
      type: String,
      default: '',
    },
    tabSelected: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dialogVisible: false,
      itemToDeleteElement: null,
      itemDeleted: false,
    };
  },

  computed: {
    bikesAreAvailable() {
      return this.bikes && this.bikes.length;
    },

    partsAreAvailable() {
      return this.parts && this.parts.length;
    },

    customWaterBottlesAreAvailable() {
      return this.customWaterBottles && this.customWaterBottles.length;
    },

    projectOneBikesAreAvailable() {
      return this.projectOneBikes && this.projectOneBikes.length;
    },

    cartIsEmpty() {
      return (
        isEmpty(this.parts) && isEmpty(this.bikes) && isEmpty(this.customWaterBottles) && isEmpty(this.projectOneBikes)
      );
    },

    currentCartProductsCombined() {
      return {
        bikes: this.bikes,
        parts: this.parts,
        customWaterBottles: this.customWaterBottles,
        projectOneBikes: this.projectOneBikes,
      };
    },
  },

  methods: {
    onTabClick(paneName) {
      this.$emit('tab-selected', paneName);
    },

    getGroupDisplayImage(product) {
      let imageSuffix =
        '?wid=160&amp;hei=120&amp;fmt=png8-alpha&amp;qlt=80,1&amp;op_usm=0,0,0,0&amp;iccEmbed=0&amp;cache=on,on';

      let image = get(product, 'entries[0].variantImage');

      return image ? ACC.scene7ProductImageUrl + image + imageSuffix : null;
    },

    getGroupDisplayColor(product) {
      let colorCode = get(product, 'entries[0].variantValueCategories[0].Color.code');
      return colorCode ? 'swatch-' + colorCode : null;
    },

    getGroupDisplayColorName(product) {
      return get(product, 'entries[0].variantValueCategories[0].Color.name');
    },

    getCollapseItemName(prefix, index) {
      return prefix + '-' + index;
    },
  },
};
</script>
